// extracted by mini-css-extract-plugin
export default {"container":"styles_container__JVcrl","count":"styles_count__PH4qx","image":"styles_image__NxxGx","textContainer":"styles_textContainer__2NDcz","fadeIn":"styles_fadeIn__TA92U"};